angular.module('components.caPurchaseOrderSingleArticleSummaryGrid', [])
    .component('caPurchaseOrderSingleArticleSummaryGrid', {
        templateUrl: 'main/order/purchaseorder/components/singlearticlesummarygrid.component.tpl.html',
        controllerAs: 'vm',
        bindings: {
            selectedArticle: '<',
            purchaseOrder: '<',
            disabled: '<',
            orderChangeCount: '<',
            onColorSelected: '&'
        },
        controller: controller
    });

// @ngInject
function controller($scope, $rootScope) {
    var vm = this;

    var colorsChoiceAndTotalsGrid = {};
    vm.currentUserClaims = $rootScope.currentUser.claims;
    vm.hasClaim = havePurchaseCostClaim()


    vm.$onInit = onInit;
    vm.$onChanges = onChanges;
    vm.$onDestroy = onDestroy;

    vm.colorsAndTotalsRows = [];

    vm.captureColorChoiceAndTotalsGrid = captureColorChoiceAndTotalsGrid;
    vm.selectColor = selectColor;

    function onInit() {
        $scope.$watch(function() { return vm.selectedArticle.id; },
                      function() {
                          loadGridData();
                          refreshGrid();
                      });

        $scope.$watch(function() { return vm.orderChangeCount; }, function() {
            loadGridData();
            refreshGrid();
        });
    }
    function onChanges() {
    }
    function onDestroy() {
    }

    function havePurchaseCostClaim(){
        if(vm.currentUserClaims.seepurchasecost === undefined){
           return false
        }

        if(!vm.currentUserClaims.seepurchasecost.read){
            return false
        }

        return true
    }

    function captureColorChoiceAndTotalsGrid(s) {
        colorsChoiceAndTotalsGrid = s;
        refreshGrid();
    }

    function selectColor(colVar) {
        var articleVariant = _.find(vm.selectedArticle.articleVariants, function(articleVariant) {
            return articleVariant.variantDetail1.variantDetailName === colVar.colorName;
        });
        vm.onColorSelected({colorVariant: articleVariant.variantDetail1});
    }

    function refreshGrid() {
        if (colorsChoiceAndTotalsGrid.invalidate) {
            colorsChoiceAndTotalsGrid.invalidate();
        }
        if (colorsChoiceAndTotalsGrid.collectionView !== undefined && colorsChoiceAndTotalsGrid.collectionView.refresh) {
            colorsChoiceAndTotalsGrid.collectionView.refresh();
        }
    }

    function getColorVariants(article) {
        var colorVariants = [];
        _.forEach(article.articleVariants, function(articleVariant) {
            if (!_.find(colorVariants, {id: articleVariant.variantDetail1.id})) {
                colorVariants.push(articleVariant.variantDetail1);
            }
        });
        return _.sortBy(colorVariants, 'sortOrder');
    }

    function getSizeVariants(article) {
        var sizeVariants = [];
        _.forEach(article.articleVariants, function(articleVariant) {
            if (!_.find(sizeVariants, {id: articleVariant.variantDetail2.id})) {
                sizeVariants.push(articleVariant.variantDetail2);
            }
        });
        return _.sortBy(sizeVariants, 'sortOrder');
    }

    function loadGridData() {
        vm.colorsAndTotalsRows.length = 0;
        var colorVariants = getColorVariants(vm.selectedArticle);

        var orderRows = [];
        _.forEach(vm.purchaseOrder.orders, function(order) {
            _.forEach(order.orderArticles, function(orderArticle) {
                if (orderArticle.article.id === vm.selectedArticle.id) {
                    _.forEach(orderArticle.orderRows, function(orderRow) {
                        orderRows.push(orderRow);
                    });
                }
            });
        });

        _.forEach(colorVariants, function(colorVariant) {
            var row = {};

            row['colorName'] = colorVariant.variantDetailName; // Display name
            row['totalQuantity'] = 0;
            row['totalCostPrice'] = 0;
            row['totalSalesPrice'] = 0;
            row['colorVariant'] = colorVariant;

            _.forEach(orderRows, function(orderRow) {
                if (colorVariant.id === orderRow.articleVariant.variantDetail1.id) {
                    row['totalQuantity'] += orderRow.quantity;
                    row['totalCostPrice'] += orderRow.quantity * orderRow.purchaseCost;
                    row['totalSalesPrice'] += orderRow.quantity * orderRow.articleVariant.salesPrice;
                }
            });

            vm.colorsAndTotalsRows.push(row);
        });
    }

}
